import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-view-more-next-arrow';
export var ID = 'icon-view-more-next-arrow';
export var SVGViewMoreNextArrow = function SVGViewMoreNextArrow() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M10,7 L2,7 L2,8 L10,8 L10,11 L14,7.5 L10,4 L10,7 Z"
  })));
};

var ViewMoreNextArrow = function ViewMoreNextArrow(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGViewMoreNextArrow
  });
};

ViewMoreNextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default ViewMoreNextArrow;